export function cue_log(cue) {
  var dynamicHTML = `Cue reached:\n
    id: ${cue.id}\n
    text: ${cue.text}\n
    startTime: ${cue.startTime}\n
    endTime: ${cue.endTime}`;
  IVP.log(dynamicHTML, 'action');
}

export function check_for_pause(cue) {
  if (cue.endTime === cue.startTime + 1) {
    return true;
  }
}
